var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm.stats
        ? _c(
            "div",
            { staticClass: "stats-row" },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.statActiveUsers"))),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.stats.active_users || 0)),
                ]),
              ]),
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("bulkGrantCleanup.statDistinctBatches"))
                  ),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.stats.distinct_batches || 0)),
                ]),
              ]),
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.statRevokedUsers"))),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.stats.revoked_users || 0)),
                ]),
              ]),
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.statVerified"))),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.stats.verified_users || 0)),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          staticClass: "cleanup-tabs",
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { name: "pending" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("bulkGrantCleanup.tabPending")) + " "
                ),
                _vm.stats && _vm.stats.pending_count > 0
                  ? _c("el-badge", {
                      staticClass: "tab-badge",
                      attrs: {
                        value: _vm.stats.pending_count,
                        type: "primary",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("el-tab-pane", { attrs: { name: "removed" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("bulkGrantCleanup.tabRemoved")) + " "
                ),
                _vm.stats && _vm.stats.removed_count > 0
                  ? _c("el-badge", {
                      staticClass: "tab-badge",
                      attrs: {
                        value: _vm.stats.removed_count,
                        type: "warning",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.stats && _vm.stats.byFeature && _vm.stats.byFeature.length
        ? _c(
            "div",
            { staticClass: "feature-breakdown" },
            [
              _c("span", { staticClass: "break-label" }, [
                _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.byFeature"))),
              ]),
              _vm._l(_vm.stats.byFeature, function (f) {
                return _c(
                  "el-tag",
                  {
                    key: f.feature_id,
                    staticClass: "feature-pill",
                    attrs: {
                      type:
                        _vm.listQuery.featureId === f.feature_id
                          ? "primary"
                          : "info",
                      effect:
                        _vm.listQuery.featureId === f.feature_id
                          ? "dark"
                          : "plain",
                      size: "small",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.filterByFeature(f.feature_id)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          f.feature_name ||
                            f.feature_key ||
                            `feat #${f.feature_id}`
                        ) +
                        " · " +
                        _vm._s(f.user_count) +
                        " "
                    ),
                  ]
                )
              }),
              _vm.listQuery.featureId
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.filterByFeature(null)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("bulkGrantCleanup.clearFilter")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "130px" },
              attrs: {
                placeholder: _vm.$t("bulkGrantCleanup.deviceType"),
                clearable: "",
              },
              model: {
                value: _vm.listQuery.deviceType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "deviceType", $$v)
                },
                expression: "listQuery.deviceType",
              },
            },
            [
              _c("el-option", { attrs: { label: "V2B", value: "V2B" } }),
              _c("el-option", { attrs: { label: "V2A", value: "V2A" } }),
              _c("el-option", { attrs: { label: "V2", value: "V2" } }),
              _c("el-option", { attrs: { label: "V1", value: "V1" } }),
            ],
            1
          ),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              placeholder: _vm.$t("bulkGrantCleanup.countryPlaceholder"),
              clearable: "",
            },
            model: {
              value: _vm.listQuery.country,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "country", $$v)
              },
              expression: "listQuery.country",
            },
          }),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "220px" },
            attrs: { placeholder: "Batch prefix (bulk-...)", clearable: "" },
            model: {
              value: _vm.listQuery.batchPrefix,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "batchPrefix", $$v)
              },
              expression: "listQuery.batchPrefix",
            },
          }),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "280px" },
            attrs: {
              placeholder: _vm.$t("bulkGrantCleanup.searchPlaceholder"),
              clearable: "",
              "prefix-icon": "el-icon-search",
            },
            on: { input: _vm.onSearchInput, clear: _vm.onSearchClear },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchQ,
              callback: function ($$v) {
                _vm.searchQ = $$v
              },
              expression: "searchQ",
            },
          }),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(_vm._s(_vm.$t("bulkGrantCleanup.filter")))]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.resetFilters },
            },
            [_vm._v(_vm._s(_vm.$t("bulkGrantCleanup.reset")))]
          ),
          _c(
            "span",
            { staticClass: "selected-summary" },
            [
              _c("strong", [_vm._v(_vm._s(_vm.selected.length))]),
              _vm._v(" " + _vm._s(_vm.$t("bulkGrantCleanup.selected")) + " "),
              _vm.selected.length > 0
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "6px" },
                      attrs: { type: "text", size: "mini" },
                      on: { click: _vm.clearSelection },
                    },
                    [_vm._v(_vm._s(_vm.$t("bulkGrantCleanup.clearSelection")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.activeTab === "pending" && _vm.selected.length > 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    icon: "el-icon-delete",
                    loading: _vm.actionLoading,
                  },
                  on: { click: _vm.confirmRevoke },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("bulkGrantCleanup.removeBulkGrants")) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeTab === "pending"
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    plain: "",
                    icon: "el-icon-delete-solid",
                    loading: _vm.actionLoading,
                  },
                  on: { click: _vm.confirmRevokeAllMatching },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("bulkGrantCleanup.removeAllMatching")) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeTab === "removed" && _vm.selected.length > 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    icon: "el-icon-circle-check",
                    loading: _vm.actionLoading,
                  },
                  on: { click: _vm.confirmVerify },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("bulkGrantCleanup.markReviewed")) + " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeTab === "removed" && _vm.selected.length > 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-refresh-left",
                    loading: _vm.actionLoading,
                  },
                  on: { click: _vm.confirmRestore },
                },
                [_vm._v(" " + _vm._s(_vm.$t("bulkGrantCleanup.restore")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.filteredList,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "row-key": (row) => row.user_id,
          },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "50",
              align: "center",
              "reserve-selection": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("bulkGrantCleanup.colDevice"),
              width: "150",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.device_product_type
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.deviceTagType(row.device_product_type),
                              size: "mini",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.device_product_type) + " ")]
                        )
                      : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                          _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.noDevice"))),
                        ]),
                    row.device_serial && !row.cane_version
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              content: _vm.$t(
                                "bulkGrantCleanup.serialFormatWarning"
                              ),
                            },
                          },
                          [
                            _c("span", { staticClass: "cane-warn-badge" }, [
                              _vm._v(
                                _vm._s(_vm.$t("bulkGrantCleanup.notPinnable"))
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    row.device_serial
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "11px",
                              "font-family": "monospace",
                              "margin-top": "2px",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.device_serial) + " ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("bulkGrantCleanup.colUser"),
              "min-width": "220",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(row.first_name) + " " + _vm._s(row.last_name)
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "font-size": "12px", color: "#888" } },
                      [_vm._v(_vm._s(row.email))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          color: "#aaa",
                          "font-family": "monospace",
                        },
                      },
                      [_vm._v(_vm._s(row.user_id))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("bulkGrantCleanup.colCountry"),
              width: "70",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.country || "-"))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("bulkGrantCleanup.colBulkFeatures"),
              "min-width": "320",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return _vm._l(row.bulk_grants, function (g) {
                    return _c(
                      "div",
                      { key: g.id, staticClass: "grant-row" },
                      [
                        _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-right": "4px" },
                            attrs: {
                              size: "mini",
                              type: _vm.grantSourceTagType(g.source_type),
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.grantSourceLabel(g.source_type)) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  g.feature_name ||
                                    g.feature_key ||
                                    `feat #${g.feature_id}`
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "grant-end" }, [
                          _vm._v(
                            "→ " +
                              _vm._s(
                                _vm.formatDate(g.end_date) ||
                                  _vm.$t("bulkGrantCleanup.noExpiry")
                              )
                          ),
                        ]),
                        g.alternatives && g.alternatives.length
                          ? _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "bulkGrantCleanup.alternativeSources"
                                        )
                                      ) +
                                      " "
                                  ),
                                  _vm._l(g.alternatives, function (a, i) {
                                    return _c("div", { key: i }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(a.source_type) +
                                          " → " +
                                          _vm._s(
                                            _vm.formatDate(a.end_date) ||
                                              _vm.$t(
                                                "bulkGrantCleanup.noExpiry"
                                              )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }),
                                ],
                                2
                              ),
                              _c("span", { staticClass: "alt-count" }, [
                                _vm._v(
                                  "+" + _vm._s(g.alternatives.length) + " alt"
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("bulkGrantCleanup.colCleanupStatus"),
              width: "180",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.cleanupStatusType(row.cleanup_status),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.cleanupStatusLabel(row.cleanup_status)) +
                            " "
                        ),
                      ]
                    ),
                    row.cleanup_status_at
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "11px",
                              color: "#909399",
                              "margin-top": "2px",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatRelativeDate(row.cleanup_status_at)
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "OTA", width: "220", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.ota &&
                    (row.ota.installed_app_version ||
                      row.ota.last_app_version ||
                      row.ota.last_reported ||
                      row.ota.override_app_version)
                      ? _c("div", { staticClass: "ota-cell" }, [
                          row.ota.override_app_version
                            ? _c(
                                "div",
                                { staticClass: "ota-override-tag" },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "warning", size: "mini" },
                                    },
                                    [_vm._v("PIN")]
                                  ),
                                  _c("span", { staticClass: "ota-version" }, [
                                    _vm._v(
                                      _vm._s(row.ota.override_app_version)
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          row.ota.installed_app_version
                            ? _c("div", { staticClass: "ota-line" }, [
                                _c("span", { staticClass: "ota-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("bulkGrantCleanup.otaInstalled")
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "ota-version" }, [
                                  _vm._v(_vm._s(row.ota.installed_app_version)),
                                ]),
                                row.ota.installed_wireless_version
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "ota-version",
                                        staticStyle: { color: "#909399" },
                                      },
                                      [
                                        _vm._v(
                                          "/ " +
                                            _vm._s(
                                              row.ota.installed_wireless_version
                                            ) +
                                            " w"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          row.ota.previous_app_version
                            ? _c(
                                "div",
                                {
                                  staticClass: "ota-line",
                                  staticStyle: { color: "#909399" },
                                },
                                [
                                  _c("span", { staticClass: "ota-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("bulkGrantCleanup.otaPrevious")
                                      )
                                    ),
                                  ]),
                                  _c("span", { staticClass: "ota-version" }, [
                                    _vm._v(
                                      _vm._s(row.ota.previous_app_version)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          !row.ota.installed_app_version &&
                          row.ota.last_reported
                            ? _c("div", { staticClass: "ota-line" }, [
                                _c("span", { staticClass: "ota-label" }, [
                                  _vm._v("app:"),
                                ]),
                                _c("span", { staticClass: "ota-version" }, [
                                  _vm._v(_vm._s(row.ota.last_reported)),
                                ]),
                              ])
                            : _vm._e(),
                          row.ota.last_app_version
                            ? _c(
                                "div",
                                {
                                  staticClass: "ota-line",
                                  staticStyle: { color: "#c0c4cc" },
                                },
                                [
                                  _c("span", { staticClass: "ota-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "bulkGrantCleanup.otaLastDownloaded"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("span", { staticClass: "ota-version" }, [
                                    _vm._v(_vm._s(row.ota.last_app_version)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#c0c4cc",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("bulkGrantCleanup.noData")))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("bulkGrantCleanup.colActions"),
              width: "90",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.openDetail(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkGrantCleanup.details")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [20, 50, 100],
          "page-size": _vm.listQuery.pageSize,
          total: _vm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.onSizeChange,
          "current-change": _vm.onPageChange,
        },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.detailTitle,
            visible: _vm.detailVisible,
            direction: "rtl",
            size: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticStyle: { padding: "16px" },
            },
            [
              _vm.detail
                ? [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.userActivity"))),
                    ]),
                    _c(
                      "el-descriptions",
                      { attrs: { column: 2, size: "small", border: "" } },
                      [
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t("bulkGrantCleanup.lastLogin"),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.detail.activity?.last_login_at
                                    ? _vm.formatRelativeDate(
                                        _vm.detail.activity.last_login_at
                                      )
                                    : "—"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t("bulkGrantCleanup.lastConsultCall"),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.detail.activity?.last_consult_at
                                    ? _vm.formatRelativeDate(
                                        _vm.detail.activity.last_consult_at
                                      )
                                    : _vm.$t("bulkGrantCleanup.never")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t("bulkGrantCleanup.consultCalls30d"),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.detail.activity?.consult_calls_30d || 0
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "bulkGrantCleanup.consultMinutes30d"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("bulkGrantCleanup.minutesShort", {
                                    n:
                                      _vm.detail.activity
                                        ?.consult_minutes_30d || 0,
                                  })
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("h4", { staticStyle: { "margin-top": "18px" } }, [
                      _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.devices"))),
                    ]),
                    _vm.detail.devices.length
                      ? _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.detail.devices,
                              border: "",
                              size: "small",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "serial_number",
                                label: _vm.$t("bulkGrantCleanup.serialNo"),
                                width: "180",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "product_type",
                                label: _vm.$t("bulkGrantCleanup.type"),
                                width: "80",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "lifecycle_status",
                                label: _vm.$t("bulkGrantCleanup.status"),
                                width: "90",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("bulkGrantCleanup.activation"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(row.activation_date)
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1467615574
                              ),
                            }),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "empty-block" }, [
                          _vm._v(
                            _vm._s(_vm.$t("bulkGrantCleanup.noActiveDevices"))
                          ),
                        ]),
                    _c("h4", { staticStyle: { "margin-top": "18px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("bulkGrantCleanup.allEntitlements"))
                      ),
                    ]),
                    _vm._l(_vm.entitlementsByFeature, function (grp) {
                      return _c(
                        "div",
                        {
                          key: grp.feature_key + grp.feature_id,
                          staticClass: "feat-group",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "feat-header" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    grp.feature_name ||
                                      grp.feature_key ||
                                      `feat #${grp.feature_id}`
                                  ) +
                                  " "
                              ),
                              _c(
                                "el-tag",
                                { attrs: { size: "mini", type: "info" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$tc(
                                        "bulkGrantCleanup.rowCount",
                                        grp.rows.length,
                                        { n: grp.rows.length }
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: grp.rows,
                                border: "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "source_type",
                                  label: _vm.$t("bulkGrantCleanup.source"),
                                  width: "170",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: _vm.sourceTypeTag(
                                                  row.source_type,
                                                  row.source_reference
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.sourceTypeLabel(
                                                      row.source_type,
                                                      row.source_reference
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("bulkGrantCleanup.start"),
                                  width: "110",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(row.start_date)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("bulkGrantCleanup.end"),
                                  width: "110",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(row.end_date) ||
                                                _vm.$t(
                                                  "bulkGrantCleanup.noExpiry"
                                                )
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("bulkGrantCleanup.status"),
                                  width: "120",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          row.is_active
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type: "success",
                                                    size: "mini",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "bulkGrantCleanup.active"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    placement: "top",
                                                    content:
                                                      row.revocation_reason ||
                                                      "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "info",
                                                        size: "mini",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.revocation_date
                                                              ? _vm.$t(
                                                                  "bulkGrantCleanup.revoked"
                                                                )
                                                              : _vm.$t(
                                                                  "bulkGrantCleanup.inactive"
                                                                )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Source ref",
                                  "min-width": "220",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "11px",
                                                "font-family": "monospace",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.source_reference || "—"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _c("h4", { staticStyle: { "margin-top": "18px" } }, [
                      _vm._v(_vm._s(_vm.$t("bulkGrantCleanup.otaVersion"))),
                    ]),
                    _c(
                      "el-descriptions",
                      { attrs: { column: 2, size: "small", border: "" } },
                      [
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t("bulkGrantCleanup.installedApp"),
                            },
                          },
                          [
                            _vm.primaryDevice &&
                            _vm.primaryDevice.installed_app_version
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-family": "monospace",
                                      color: "#303133",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.primaryDevice
                                            .installed_app_version
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("—")]
                                ),
                            _vm.primaryDevice &&
                            _vm.primaryDevice.installed_reported_at
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#909399",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRelativeDate(
                                            _vm.primaryDevice
                                              .installed_reported_at
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "bulkGrantCleanup.installedWireless"
                              ),
                            },
                          },
                          [
                            _vm.primaryDevice &&
                            _vm.primaryDevice.installed_wireless_version
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-family": "monospace",
                                      color: "#303133",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.primaryDevice
                                            .installed_wireless_version
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("—")]
                                ),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t("bulkGrantCleanup.previousApp"),
                            },
                          },
                          [
                            _vm.primaryDevice &&
                            _vm.primaryDevice.previous_app_version
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-family": "monospace",
                                      color: "#606266",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.primaryDevice.previous_app_version
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("—")]
                                ),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "bulkGrantCleanup.previousWireless"
                              ),
                            },
                          },
                          [
                            _vm.primaryDevice &&
                            _vm.primaryDevice.previous_wireless_version
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-family": "monospace",
                                      color: "#606266",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.primaryDevice
                                            .previous_wireless_version
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("—")]
                                ),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "bulkGrantCleanup.appReportedVersion"
                              ),
                            },
                          },
                          [
                            _vm.detail.ota?.last_reported_app_version
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { "font-family": "monospace" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.detail.ota
                                            .last_reported_app_version
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("—")]
                                ),
                            _vm.detail.ota?.last_reported_at
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#909399",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRelativeDate(
                                            _vm.detail.ota.last_reported_at
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "bulkGrantCleanup.lastDownloadedOta"
                              ),
                            },
                          },
                          [
                            _vm.detail.ota?.last_download
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { "font-family": "monospace" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.detail.ota.last_download
                                            .application_version_name || "—"
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("bulkGrantCleanup.never"))
                                    ),
                                  ]
                                ),
                            _vm.detail.ota?.last_download
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#909399",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRelativeDate(
                                            _vm.detail.ota.last_download
                                              .downloaded_at
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ota-override-block" },
                      [
                        _c(
                          "div",
                          { staticClass: "ota-override-header" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("bulkGrantCleanup.manualPin"))
                              ),
                            ]),
                            (_vm.detail.ota?.overrides || []).length
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "mini" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$tc(
                                            "bulkGrantCleanup.activePins",
                                            (_vm.detail.ota?.overrides || [])
                                              .length,
                                            {
                                              n: (
                                                _vm.detail.ota?.overrides || []
                                              ).length,
                                            }
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("bulkGrantCleanup.noPin"))
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                        _c("pin-list", {
                          attrs: {
                            pins: _vm.cleanupPinItems,
                            "removing-key": _vm.removingPinKey,
                          },
                          on: { remove: _vm.removePinRow },
                        }),
                        _vm.detailRow
                          ? _c("pin-form", {
                              attrs: {
                                "user-id": _vm.detailRow.user_id,
                                "user-devices": _vm.activeDevices,
                                "user-pins": _vm.cleanupPinItems,
                                "available-ota-files": _vm.cleanupOtaFiles,
                                "allow-user-scope": true,
                              },
                              on: { saved: _vm.onPinSaved },
                            })
                          : _vm._e(),
                        _c("div", { staticClass: "ota-help" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("bulkGrantCleanup.otaHelp")) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm.detail.audit_history && _vm.detail.audit_history.length
                      ? _c("h4", { staticStyle: { "margin-top": "18px" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("bulkGrantCleanup.actionHistory")) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.detail.audit_history && _vm.detail.audit_history.length
                      ? _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.detail.audit_history,
                              border: "",
                              size: "small",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("bulkGrantCleanup.time"),
                                width: "160",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatRelativeDate(
                                              row.performed_at
                                            )
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                906789287
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "action",
                                label: _vm.$t("bulkGrantCleanup.action"),
                                width: "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: _vm.auditActionType(
                                                row.action
                                              ),
                                            },
                                          },
                                          [_vm._v(_vm._s(row.action))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                413520340
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("bulkGrantCleanup.affectedRows"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              Array.isArray(
                                                row.affected_entitlement_ids
                                              )
                                                ? row.affected_entitlement_ids
                                                    .length
                                                : 0
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1341739497
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "performed_by",
                                label: _vm.$t("bulkGrantCleanup.performedBy"),
                                width: "120",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "24px",
                          display: "flex",
                          gap: "8px",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              loading: _vm.actionLoading,
                            },
                            on: { click: _vm.revokeOne },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("bulkGrantCleanup.removeBulkGrant")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { loading: _vm.actionLoading },
                            on: { click: _vm.restoreOne },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("bulkGrantCleanup.restorePrevious")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }